var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C8.72207 2.75 6.32207 3.24227 4.78217 4.78217C3.24227 6.32207 2.75 8.72207 2.75 12C2.75 15.2779 3.24227 17.6779 4.78217 19.2178C6.32207 20.7577 8.72207 21.25 12 21.25C15.2779 21.25 17.6779 20.7577 19.2178 19.2178C20.7577 17.6779 21.25 15.2779 21.25 12C21.25 8.72207 20.7577 6.32207 19.2178 4.78217C17.6779 3.24227 15.2779 2.75 12 2.75ZM10.4608 9.73312C10.1025 9.8227 9.82276 10.1024 9.73319 10.4607L8.86872 13.9186C8.68562 14.651 9.34902 15.3144 10.0814 15.1313L13.5393 14.2668C13.8975 14.1772 14.1773 13.8975 14.2669 13.5392L15.1313 10.0813C15.3144 9.34896 14.651 8.68556 13.9187 8.86866L10.4608 9.73312Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreSolid);
export default __webpack_public_path__ + "static/media/explore-solid.7b7748d67762128b957319cef8d9b2f4.svg";
export { ForwardRef as ReactComponent };